// extracted by mini-css-extract-plugin
export default {"Footer__price":"Footer_Footer__price__Y2M2M","Footer__view":"Footer_Footer__view__ODVhY"};